import * as React from 'react';
import ReactHtmlParser from 'html-react-parser';
import styled from 'styled-components';
import { IValidationErrorCollection } from '../../../models';
import { ErrorMessageLabel } from '../SharedComponents';

export const DistributionWarningsContainer = styled.div`
	max-height: 200px;
	overflow-y: auto;
	text-align: left;
`;
DistributionWarningsContainer.displayName = 'DistributionWarningsContainer';

export interface IFileUploadWarningProps {
	distributionValidationWarnings?: IValidationErrorCollection;
}

export class FileUploadWarning extends React.Component<IFileUploadWarningProps, {}> {
	constructor(props: IFileUploadWarningProps) {
		super(props);
	}

	public render() {
		const { distributionValidationWarnings } = this.props;
		return (
			<>
				{distributionValidationWarnings && (
					<>
						<DistributionWarningsContainer>
							<div>File Warnings: </div>
							{Object.keys(distributionValidationWarnings).map((key) => {
								return (
									<ErrorMessageLabel key={key}>
										{distributionValidationWarnings[key].map((warning: string) => ReactHtmlParser(warning))}
									</ErrorMessageLabel>
								);
							})}
						</DistributionWarningsContainer>
					</>
				)}
			</>
		);
	}
}
